<template>
    <div class="row just-content-between align-items-center bg-yellow p-2">
        <div class="col pl-1">
            <div class="d-flex align-items-center">
                <img src="/images/money.png" class="img-fluid money-icon"> 我的積分
            </div>
        </div>
        <div class="col pr-1 text-right">{{ point }} 分</div>
    </div>
</template>

<script>
export default {
    name: 'my-point',

    props: [
        'point'
    ]
}
</script>

<style>
.money-icon {
    width: 20%;
}
</style>
